import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Youtube, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="pt-5 pb-3" style={{ background: 'linear-gradient(to right, #FFFFFF, #1d384e)' }}>
      <Container>
        <Row className="mb-4">
          <Col lg={3} md={6} className="mb-4">
            <div className="d-flex align-items-center mb-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_modern-bs5-site/artifacts/eelqdwqk_ChatGPT%20Image%20Nov%2010%2C%202025%2C%2011_44_19%20PM.png" 
                alt="FURRMAA Logo" 
                style={{ height: '40px', width: 'auto', marginRight: '10px' }}
              />
              <h5 className="fw-bold mb-0" style={{ color: '#001F3F' }}>FURRMAA</h5>
            </div>
            <p className="small text-dark">
              Your ultimate online pet store! We're more than just a pet food shop - we're your partners in pet parenting.
            </p>
          </Col>
          
          <Col lg={3} md={6} className="mb-4">
            <h6 className="fw-bold mb-3 text-dark">Quick Links</h6>
            <ul className="list-unstyled">
              <li className="mb-2"><Link to="/" className="text-dark text-decoration-none">Home</Link></li>
              <li className="mb-2"><Link to="/products" className="text-dark text-decoration-none">Products</Link></li>
              <li className="mb-2"><Link to="/about" className="text-dark text-decoration-none">About Us</Link></li>
              <li className="mb-2"><Link to="/contact" className="text-dark text-decoration-none">Contact</Link></li>
            </ul>
          </Col>
          
          <Col lg={3} md={6} className="mb-4">
            <h6 className="fw-bold mb-3 text-dark">Categories</h6>
            <ul className="list-unstyled">
              <li className="mb-2"><Link to="/products?category=dog" className="text-dark text-decoration-none">Dog Products</Link></li>
              <li className="mb-2"><Link to="/products?category=cat" className="text-dark text-decoration-none">Cat Products</Link></li>
              <li className="mb-2"><Link to="/products?category=bird" className="text-dark text-decoration-none">Bird Products</Link></li>
              <li className="mb-2"><Link to="/products?category=treats" className="text-dark text-decoration-none">Treats & Toys</Link></li>
            </ul>
          </Col>
          
          <Col lg={3} md={6} className="mb-4">
            <h6 className="fw-bold mb-3 text-dark">Contact Us</h6>
            <ul className="list-unstyled">
              <li className="mb-2 d-flex align-items-start">
                <MapPin size={18} className="me-2 mt-1" style={{ color: '#001F3F' }} />
                <span className="text-dark small">123 Pet Street, Animal City, AC 12345</span>
              </li>
              <li className="mb-2 d-flex align-items-center">
                <Phone size={18} className="me-2" style={{ color: '#001F3F' }} />
                <span className="text-dark small">+1 (555) 123-4567</span>
              </li>
              <li className="mb-2 d-flex align-items-center">
                <Mail size={18} className="me-2" style={{ color: '#001F3F' }} />
                <span className="text-dark small">support@furrmaa.com</span>
              </li>
            </ul>
          </Col>
        </Row>
        
        <hr style={{ borderColor: 'rgba(0, 31, 63, 0.2)' }} />
        
        <Row className="align-items-center">
          <Col md={6} className="text-center text-md-start mb-3 mb-md-0">
            <p className="mb-0 small text-dark">
              &copy; 2025 FURRMAA. All rights reserved.
            </p>
          </Col>
          <Col md={6} className="text-center text-md-end">
            <div className="d-flex justify-content-center justify-content-md-end gap-3">
              <a href="#" className="text-dark" style={{ opacity: 0.7 }}>
                <Facebook size={20} />
              </a>
              <a href="#" className="text-dark" style={{ opacity: 0.7 }}>
                <Twitter size={20} />
              </a>
              <a href="#" className="text-dark" style={{ opacity: 0.7 }}>
                <Instagram size={20} />
              </a>
              <a href="#" className="text-dark" style={{ opacity: 0.7 }}>
                <Youtube size={20} />
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;